export const CREATE_PURITY = "[PURITY] CREATE";
export const DELETE_PURITY = "[PURITY] DELETE";
export const UPDATE_PURITY = "[PURITY] UPDATE";
export const TOTALDISPATCH_PURITY = "[PURITY] TOTALDISPATCH";

export const createDispatchItem = (payload) => ({
  //always caps
  type: CREATE_PURITY,
});

export const updateDispatchItem = (payload) => ({
  //always caps
  type: UPDATE_PURITY,
  payload: payload,
});

export const deleteDispatchItem = (payload) => ({
  //always caps
  type: DELETE_PURITY,
  payload: payload,
});

export const setTotalDispatchItem = (payload) => ({
  type: TOTALDISPATCH_PURITY,
  payload: payload,
});
